// Footer.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';  // Ensure icons are imported if not already

const Footer = () => {
    return (
        <footer className="text-white mt-5" style={{ backgroundColor: '#AEC15F' }}>
            <Container fluid>
                <Row className="py-3">
                    <Col xs={12} md={3} className="text-left text-md-left">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img src="/logo-saarthi.svg" alt="Logo" height="50" style={{ marginRight: '10px' }} />
                            <h4 style={{ marginBottom: '0' }}>Saarthi</h4>
                        </div>
                    </Col>
                    <Col xs={12} md={3} className="text-left text-md-left">
                        <h5>Contact Us</h5>
                        <p>Email: support@saarthi.cloud</p>
                    </Col>
                    <Col xs={12} md={3} className="text-center">
                        <h5>Quick Links</h5>
                        <ul className="list-unstyled">
                            <li><a href="/about_us" className="text-white">About Us</a></li>
                            <li><a href="/faq" className="text-white">FAQ</a></li>
                            <li><a href="/privacy" className="text-white">Privacy Policy</a></li>
                        </ul>
                    </Col>
                    <Col xs={12} md={3} className="text-center text-md-right">
                        <h5>Follow Us</h5>
                        <a href="http://facebook.com" className="text-white mx-1">
                            <i className="bi bi-facebook"></i>
                        </a>
                        <a href="http://twitter.com" className="text-white mx-1">
                            <i className="bi bi-twitter"></i>
                        </a>
                        <a href="http://instagram.com" className="text-white mx-1">
                            <i className="bi bi-instagram"></i>
                        </a>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={3} className="text-left py-3">
                        © 2024 Saarthi
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
